// extracted by mini-css-extract-plugin
export default {"area":"LetsBegin_area__6h7kG","circles":"LetsBegin_circles__mCwKO","animate":"LetsBegin_animate__+1zxT","beginText":"LetsBegin_beginText__TpA8z"};